import { Box, SxProps } from '@mui/material';
import React, { ReactNode } from 'react';

import { WIDTH_MODAL_COMPONENTS } from '../../../../../constants/addressBook';

interface IProps {
  children: ReactNode;
  sx?: SxProps;
}

const ToastWrapper: React.FC<IProps> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 8,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10,
        width: { md: WIDTH_MODAL_COMPONENTS / 2, lg: WIDTH_MODAL_COMPONENTS },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default ToastWrapper;
